import { render, staticRenderFns } from "./parent-regist.vue?vue&type=template&id=6963d8fe&"
import script from "./parent-regist.vue?vue&type=script&lang=js&"
export * from "./parent-regist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports